import axios from 'axios';

export default {
  baseURL: process.env.BASE_URL + 'api/download',

  getDownloadFile(downloadToken, cancelToken) {
    return axios.get('',
      { 
        baseURL: this.baseURL + '/' + downloadToken,
        responseType: 'blob',
        cancelToken: cancelToken ? cancelToken.token : null
      })
      .then(function (response) {
        return response;
      })
      .catch(function (error) {
        if (!axios.isCancel(error)) {
          console.error(error);
        }
        
        return Promise.reject(error);
      });
  }
};